'use strict';

(function() {
	var character = $('.character');
	var slider = {
		wrapper: character.find('.slider-wrapper'),
		main: character.find('.main-slider'),
		detail: character.find('.detail-slider')
	};
	var button = {
		prev: character.find('.main-slider-button--prev'),
		next: character.find('.main-slider-button--next')
	};

	// メインスライダー
	slider.main.slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		focusOnSelect: true,
		speed: 500,
		infinite: false,
		initialSlide: 1,
		prevArrow: button.prev,
		nextArrow: button.next
	});

	// 詳細スライダー
	slider.detail.slick({
		dots: false,
		arrows: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		focusOnSelect: true,
		speed: 500,
		touchMove: false,
		infinite: true,
		swipe: false,
	});

	button.prev.on('click', function() {
		slider.main.slick('slickPrev');
		return false;
	});

	button.next.on('click', function() {
		slider.main.slick('slickNext');
		return false;
	});

	// スライド移動後に各種スライドと連動させる
	slider.main.on('afterChange', function(slick, currentSlide, nextSlide) {
		switch (nextSlide) {
			case 0:
			case 1:
			// case 2:
				slider.detail.slick('slickGoTo', 0);
				break;
		}

		// 左右ボタンとの連動
		slider.wrapper.removeClass(function(index, className) {
			return (className.match(/\bprev\S+/g) || []).join(' ');
		});

		slider.wrapper.removeClass(function(index, className) {
			return (className.match(/\bnext\S+/g) || []).join(' ');
		});

		switch (nextSlide) {
			case 0:
				slider.wrapper.addClass('next-shinka');
				break;
			case 1:
				slider.wrapper.addClass('prev-shinkamae');
				// slider.wrapper.addClass('next-kamika');
				break;
			// case 2:
				// slider.wrapper.addClass('prev-shinka');
				// break;
		}
	});

})();

///// モーダル
(function() {
	var speed = 200;
	var body = $('body');

	$('.js-modalTrigger').on('click', function() {
		var targetImg = $(this).data('src');
		$('.js-modal_overlay').fadeIn(speed);
		$('.js-modal_content').fadeIn(speed);
		$('.js-modal_img img').attr('src', targetImg)
		body.addClass('is-modal');
	});

	$('.js-modal_overlay, .js-modal_close').on('click', function() {
		$('.js-modal_overlay, .js-modal_content').fadeOut(speed);
		body.removeClass('is-modal');
	});
})();

new WOW().init();
